import React from 'react';
interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  id?: string;
}
export function SectionHeading({
  eyebrow,
  title,
  description,
  id
}: SectionHeadingProps) {
  return <div className="mx-auto flex max-w-2xl flex-col items-center gap-2 text-center" data-id="element-228" data-mp="3f25av1fguej3">
      {eyebrow && <p className="text-xs font-bold uppercase tracking-[0.22em] text-blush" data-id="element-229" data-mp="3k0yjaffwbfce">
          {eyebrow}
        </p>}
      <h2 id={id} className="font-display text-2xl md:text-3xl font-bold uppercase leading-tight text-ink" data-id="element-230" data-mp="bl588g4c2w2q">
        {title}
      </h2>
      {description && <p className="text-base leading-relaxed text-ink-muted" data-id="element-231" data-mp="1u0vln24rnb2">
          {description}
        </p>}
    </div>;
}